<script setup lang="ts">
import HeroIcons from '@/components/ui/icons/HeroIcons.vue';

defineProps<{
  pageSize: number
}>()

function generatePageNumbers(nbHits, pageSize) {
  const totalPages = Math.floor(nbHits / pageSize);
  const pageNumbers: number[] = [];

  for (let i = 0; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return pageNumbers;
}
</script>
<template>
  <ais-pagination>
    <template v-slot="{
      currentRefinement,
      nbHits,
      nbPages,
      pages,
      isFirstPage,
      isLastPage,
      refine,
      createURL
    }">
      <Teleport to="#count-claims">
        {{ nbHits }}
      </Teleport>
      <ul class="flex items-center justify-between px-4 py-3 bg-white border-t border-gray-200 sm:px-6">
        <div class="flex justify-between flex-1 sm:hidden">
          <li v-if="!isFirstPage"
            class="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50">
            <a :href="createURL(currentRefinement - 1)" @click.prevent="refine(currentRefinement - 1)">
              Précédent
            </a>
          </li>
          <li v-if="!isLastPage"
            class="relative inline-flex items-center px-4 py-2 ml-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50">
            <a :href="createURL(currentRefinement + 1)" @click.prevent="refine(currentRefinement + 1)">
              Suivant
            </a>
          </li>
        </div>
        <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
          <div>
            <p class="text-sm text-gray-700">
              Affichage de
              {{ ' ' }}
              <span class="font-medium">{{ (pageSize * currentRefinement)  }}</span>
              {{ ' ' }}
              à
              {{ ' ' }}
              <span class="font-medium">{{ pageSize * (currentRefinement + 1) }}</span>
              {{ ' ' }}
              sur
              {{ ' ' }}
              <span class="font-medium">{{ nbHits }}</span>
              {{ ' ' }}
              résultats
            </p>
          </div>
          <div>
            <nav class="relative z-0 inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
              <li>
                <a :href="createURL(currentRefinement - 1)"
                  @click.prevent="!isFirstPage ? refine(currentRefinement - 1) : null"
                  class="relative inline-flex items-center px-2 py-2 text-sm font-medium bg-white border border-gray-300 rounded-l-md hover:bg-gray-50"
                  :class="isFirstPage ? 'text-gray-200 cursor-default' : 'text-gray-500'" :disabled="isFirstPage">
                  <span class="sr-only">Previous</span>
                  <HeroIcons name="ChevronLeftIcon" class="w-5 h-5" :solid="true" aria-hidden="true" />
                </a>
              </li>
              <!-- Current: "z-10 bg-blue-50 border-blue-500 text-blue-600", Default: "bg-white border-gray-300 text-gray-500 hover:bg-gray-50" -->
              <li v-for="page in generatePageNumbers(nbHits, pageSize)" :key="page">
                <a :href="createURL(page)" aria-current="page"
                  @click.prevent="refine(page)"
                  class="relative inline-flex items-center px-4 py-2 text-sm font-medium" :class="page === currentRefinement
                  ? 'text-blue-600 border border-blue-500 bg-blue-50 z-30'
                  : 'text-gray-500 bg-white border border-gray-300 hover:bg-gray-50 z-10'">
                  {{ page + 1 }}
                </a>
              </li>


              <li>
                <a :href="createURL(currentRefinement - 1)"
                  @click.prevent="!isLastPage ? refine(currentRefinement + 1) : null"
                  class="relative inline-flex items-center px-2 py-2 text-sm font-medium bg-white border border-gray-300 rounded-r-md hover:bg-gray-50"
                  :class="isLastPage ? 'text-gray-200 cursor-default' : 'text-gray-500'" :disabled="isLastPage">
                  <span class="sr-only">Previous</span>
                  <HeroIcons name="ChevronRightIcon" class="w-5 h-5" :solid="true" aria-hidden="true" />
                </a>
              </li>
            </nav>
          </div>
        </div>
      </ul>
    </template>
  </ais-pagination>
</template>